import type { Component, JSX } from "solid-js";
import { A } from "@solidjs/router";
import styles from "./MobileSignUpButton.module.css";

export interface MobileSignUpButtonProps {
  href: string;
  onClick: (event: MouseEvent) => void;
  children: JSX.Element;
}

export const MobileSignUpButton: Component<MobileSignUpButtonProps> = (props) => {
  return (
    <A href={props.href} class={styles.mobileSignUpButton} onClick={props.onClick}>
      {props.children}
    </A>
  );
};
